import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { calculateSpacing, breakpoints } from '@vds-core/theme';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
import Icon, { IconData } from '@vds-core/icons';
var propTypes = {
  /**
   * @ignore
   */
  alertType: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * @ignore
   */
  controlFunc: PropTypes.func.isRequired,

  /**
   * @ignore
   */
  visible: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  size: PropTypes.string,

  /**
   * @ignore
   */
  iconConfig: PropTypes.object,

  /**
   * @ignore
   */
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * @ignore
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   */
  activeState: PropTypes.bool,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore
   */
  contentColor: PropTypes.string,

  /**
   * @ignore
   * adds additional hit area to the trigger
   */
  hitArea: PropTypes.bool,

  /**
   * @ignore
   * determines the height of the close button
   */
  closeButtonHeight: PropTypes.string
};
var defaultProps = {
  alertType: 'success',
  size: 'medium',
  iconConfig: IconData,
  //added after renaming
  type: 'success',
  focusState: false,
  activeState: false,
  hitArea: false,
  closeButtonHeight: calculateRem(20)
};
var StyledButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledButton",
  componentId: "sc-4z0w5p-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n\n  background: transparent;\n  border: 0;\n  padding: 0;\n  margin-left: ", ";\n  height: ", ";\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:active,\n  &:hover,\n  &:visited {\n    outline: none;\n  }\n\n  ", ";\n\n  ", ";\n"])), calculateSpacing('3X'), function (_ref) {
  var closeButtonHeight = _ref.closeButtonHeight;
  return closeButtonHeight;
}, function (_ref2) {
  var activeState = _ref2.activeState,
      colorConfig = _ref2.colorConfig;
  return activeState && "\n      &:active svg g path {\n        stroke: ".concat(colorConfig.coolGray6, ";\n      }\n  ");
}, function (_ref3) {
  var focusState = _ref3.focusState,
      alertType = _ref3.alertType,
      type = _ref3.type,
      contentColor = _ref3.contentColor;
  return focusState && "\n    &:focus {\n      &:not(:active):not(:visited):not(:hover) {\n        outline: ".concat(calculateRem(1), " dashed ").concat(contentColor, ";\n        outline-offset: ").concat(calculateRem(2), ";\n      }\n    }\n  ");
});
var HitArea = /*#__PURE__*/styled.span.withConfig({
  displayName: "HitArea",
  componentId: "sc-4z0w5p-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -90%;\n  right: -100%;\n  cursor: pointer;\n  display: inline-block;\n  height: ", ";\n  width: ", ";\n  z-index: 1;\n"])), calculateRem(48), calculateRem(48));
/**
 * @ignore
 */

var NotificationClose = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationClose, _React$Component);

  var _super = _createSuper(NotificationClose);

  function NotificationClose(props) {
    var _this;

    _classCallCheck(this, NotificationClose);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "refPath", UNSAFE_SetEnvRef());

    _defineProperty(_assertThisInitialized(_this), "_clickClose", function (e) {
      _this.props.controlFunc(e);
      /* istanbul ignore else  */


      if (e.type === 'click') e.currentTarget.blur();
    });

    _this.state = {
      isHovered: false
    };
    _this.closeRef = null;
    _this._toggleHover = _this._toggleHover.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NotificationClose, [{
    key: "_toggleHover",
    value: function _toggleHover() {
      this.setState(function (prevState) {
        return {
          isHovered: !prevState.isHovered
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          alertType = _this$props.alertType,
          type = _this$props.type,
          colorConfig = _this$props.colorConfig,
          contentColor = _this$props.contentColor,
          controlFunc = _this$props.controlFunc,
          visible = _this$props.visible,
          size = _this$props.size,
          iconConfig = _this$props.iconConfig,
          focusState = _this$props.focusState,
          activeState = _this$props.activeState,
          hitArea = _this$props.hitArea,
          closeButtonHeight = _this$props.closeButtonHeight,
          cta = _this$props.cta,
          level = _this$props.level,
          position = _this$props.position,
          dataTrack = _this$props.dataTrack,
          id = _this$props.id;
      return /*#__PURE__*/React.createElement(StyledButton, _extends({
        closeButtonHeight: closeButtonHeight,
        onMouseEnter: this._toggleHover,
        onMouseLeave: this._toggleHover,
        colorConfig: colorConfig,
        activeState: activeState,
        focusState: focusState,
        contentColor: contentColor,
        onClick: this._clickClose,
        tabIndex: visible ? 0 : -1,
        id: id,
        "data-testid": "Notification-close-button",
        "aria-label": "Notification Close",
        role: "button",
        "data-sitecat-level": level,
        "data-sitecat-cta": cta,
        "data-sitecat-datatrack": dataTrack,
        "data-sitecat-position": position
      }, _defineProperty({}, this.refPath, function (elem) {
        return _this2.closeRef = elem;
      })), /*#__PURE__*/React.createElement(Icon, {
        hasStroke: true,
        ariaHidden: true,
        weight: this.state.isHovered ? 'medium' : 'light',
        data: iconConfig,
        size: size,
        tabIndex: -1,
        color: contentColor,
        name: "close",
        vectorEffect: "non-scaling-stroke"
      }), hitArea && /*#__PURE__*/React.createElement(HitArea, null));
    }
  }]);

  return NotificationClose;
}(React.Component);

NotificationClose.propTypes = propTypes;
NotificationClose.defaultProps = defaultProps;
export default NotificationClose;